import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    intern:false,
    token: null,
    email: null,
    user: {},
    guest: false,
    guest_user: {},
  },
  mutations: {
    set: (state, data) => state[data.key]=data.value,
  },
  actions: {
  },
  modules: {
  }
})
